import React from 'react'
import styles from './FooterSection.module.scss'

function scrollToSection(id) {
    setTimeout(() => {
        const el = document.getElementById(id)
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 0)
}

export default function FooterSection() {
    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.left}>
                    <div className={styles.logo}>
                        <img src='/img/Header/logo.svg' alt='' />
                    </div>
                    <p>
                        <b>ИП Хабибуллина Регина Рафаэлевна</b>
                    </p>
                    <p>ОГРН: 319169000152570</p>
                    <p>ИНН: 165915722334</p>
                    {/* <p>759082, Россия, Республика Татарстан</p>
                    <p>г. Казань, ул. Четаева 28</p> */}
                </div>

                <nav className={styles.navCol}>
                    <ul>
                        <li>
                            <a
                                href='#courses'
                                onClick={(e) => {
                                    e.preventDefault()
                                    scrollToSection('courses')
                                }}
                            >
                                Направления
                            </a>
                        </li>
                        <li>
                            <a
                                href='#achievements'
                                onClick={(e) => {
                                    e.preventDefault()
                                    scrollToSection('achievements')
                                }}
                            >
                                Результаты
                            </a>
                        </li>
                        <li>
                            <a
                                href='#pricing'
                                onClick={(e) => {
                                    e.preventDefault()
                                    scrollToSection('pricing')
                                }}
                            >
                                Стоимость
                            </a>
                        </li>
                        <li>
                            <a
                                href='#contacts'
                                onClick={(e) => {
                                    e.preventDefault()
                                    scrollToSection('contacts')
                                }}
                            >
                                Контакты
                            </a>
                        </li>
                    </ul>
                </nav>

                <nav className={styles.navCol}>
                    <ul>
                        <li>
                            <a
                                href='/docs/public-offer.pdf' 
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                Публичная оферта
                            </a>
                        </li>
                        <li>
                            <a
                                href='/docs/privacy-policy.pdf'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                Положение об обработке персональных данных
                            </a>
                        </li>
                        <li>
                            <a
                                href='/docs/education-license.pdf'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                Образовательная лицензия
                            </a>
                        </li>
                    </ul>
                </nav>

                <div className={styles.right}>
                    <div className={styles.phoneRow}>
                        <svg
                            className={styles.phoneIcon}
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            aria-hidden='true'
                        >
                            <path d='M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13 1.21.37 2.39.72 3.5a2 2 0 0 1-.45 2.11L9 10.91a16 16 0 0 0 6 6l1.58-1.58a2 2 0 0 1 2.11-.45c1.11.35 2.29.59 3.5.72a2 2 0 0 1 1.72 2z' />
                        </svg>
                        <a href='tel:+79003248282' className={styles.phoneNumber}>
                            +7 900 324-82-82
                        </a>
                    </div>
                    <div className={styles.socials}>
                        <a
                            href='https://wa.me/79003248282'
                            aria-label='WhatsApp'
                            target='_blank'
                            rel='noopener noreferrer'
                            className={styles.socialLink}
                        >
                            <img src='/img/icons/whatsapp.svg' alt='WhatsApp' />
                        </a>
                        <a
                            href='https://vk.com/progium.kazan'
                            aria-label='VK'
                            target='_blank'
                            rel='noopener noreferrer'
                            className={styles.socialLink}
                        >
                            <img src='/img/icons/vk.svg' alt='VK' />
                        </a>
                        <a
                            href='https://t.me/progium'
                            aria-label='Telegram'
                            target='_blank'
                            rel='noopener noreferrer'
                            className={styles.socialLink}
                        >
                            <img src='/img/icons/telegram.svg' alt='Telegram' />
                        </a>
                        {/* Новая иконка: MAX */}
                        <a
                            href='tel:+79003248282'
                            aria-label='MAX'
                            className={styles.socialLink}
                        >
                            <img src='/img/icons/max.svg' alt='MAX' />
                        </a>
                        {/* Новая иконка: ДЗЕН */}
                        <a
                            href='https://dzen.ru/progiumru?share_to=link'
                            aria-label='Dzen'
                            target='_blank'
                            rel='noopener noreferrer'
                            className={styles.socialLink}
                        >
                            <img src='/img/icons/dzen.svg' alt='Дзен' />
                        </a>
                    </div>
                    <button
                        className={styles.ctaButton}
                        onClick={() => scrollToSection('form-section')}
                    >
                        Оставить заявку
                    </button>
                </div>
            </div>
        </footer>
    )
}
